<template>
  <v-dialog
    width="500"
    v-bind="$attrs"
    v-on="$listeners"
    @click:outside="onCancel"
  >
    <v-card>
      <v-card-title>
        Novo grupo
      </v-card-title>

      <v-card-text>
        <v-progress-linear
          v-if="loading"
          color="amber"
          indeterminate
        />
        <v-form
          ref="form"
        >
          <v-text-field
            v-model="title"
            prepend-icon="mdi-note-text"
            persistent-hint
            :error-messages="formErrors.title"
            :disabled="loading"
            label="Titulo do grupo (Área de conhecimento)"
            hint="Ex: Linguagens, Códigos e suas Tecnologias"
            @input="formErrors.title = ''"
          />
          <v-text-field
            v-model="subtitle"
            prepend-icon="mdi-note-text"
            persistent-hint
            :error-messages="formErrors.subtitle"
            :disabled="loading"
            label="Subtitulo do grupo (ex: Disciplinas) (opcional)"
            hint="Ex: Língua Portuguesa, Literatura, Língua Inglesa, Língua Espanhola e Arte."
            @input="formErrors.subtitle = ''"
          />
        </v-form>
      </v-card-text>
      <v-card-text>
        <div class="d-flex justify-space-between">
          <v-btn
            color="primary"
            text
            @click="onCancel"
          >
            fechar
          </v-btn>
          <v-btn
            color="primary"
            text
            @click="onSubmit()"
          >
            Salvar
          </v-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import handlesServerValidation from '@/mixins/handles-server-validation.js'
import dayjs from '@/dayjs.js'

export default {
  mixins: [
    handlesServerValidation
  ],

  props: {
    idExam: { type: Number, default: null }
  },

  data: () => ({
    title: null,
    subtitle: null,
    loading: false
  }),
  methods: {
    onCancel () {
      this.$emit('resolve', false)
    },

    async onSubmit () {
      this.loading = true
      try {
        const data = {
          title: this.title,
          subtitle: this.subtitle
        }
        await this.$api.newQuestionGroups(this.idExam, data)
        this.$store.dispatch('setSnackBar', { text: 'Grupo criado com sucesso.' })
        this.$emit('resolve', true)
      } catch (e) {
        this.$store.dispatch('setSnackBar', { text: 'Ocorreu um erro ao tentar criar o Grupo.', color: 'red' })
        this.getErrors(e)
      } finally {
        this.loading = false
      }
    },
    dayjs
  }
}
</script>
